import { UIMHomepageController } from './homepage/UIMHomepageController.ts';
import { UIMLeaderboardController } from './leaderboard/UIMLeaderboardController.ts';
import { UIMLobbyController } from './lobby/UIMLobbyController.ts';
import { UIMStoreController } from './store/UIMStoreController.ts';
import { UIMStoreBodyController } from './store/UIMStoreBodyController.ts';
import { Splide } from '@splidejs/splide';
import { UIUtilsEjsVariables } from '../../../../../shared/scripts/UIUtilsEjsVariables.ts';
import { UIMSceneEnum } from '../../../../../../shared/enums/UIMSceneEnums.ts';
import { UIModeSelectorController } from '../../../../../shared/scripts/ui_html/home_page/UIModeSelectorController.ts';
import { UIMModeSelectorDetailsController } from './homepage/UIMModeSelectorDetailsController.ts';
import { mountMorePage } from '../../../../../shared/scripts/more/mountMorePage.ts';
import { getMobileRulebookUrl, navigateToPage } from '../../../../../shared/scripts/ui_utils/ClientUtils.ts';
import { uiManager } from '../../../EntryMobile.ts';
import { StorageWrapper } from '../../../../../shared/scripts/StorageWrapper.ts';
import { FAQ_URL } from '@colonist/consts';
export class UIMBodyController {
    slideChange(scene) {
        const isStoreHidden = UIUtilsEjsVariables.shouldHideStoreOnMobile;
        const mappedScene = isStoreHidden && scene >= UIMSceneEnum.Store ? scene + 1 : scene;
        this.sceneController.loadScene(mappedScene);
    }
    hide() {
        this.bodyContainer.style.display = 'none';
        this.homepageController.onHomepageHide();
    }
    show() {
        this.bodyContainer.style.display = 'block';
    }
    onHomepageShow() {
        this.modeSelectorController.onHomepageShow();
    }
    onStoreShow() {
        if (!(this.storeController.bodyController instanceof UIMStoreBodyController)) return;
        this.storeController.bodyController.onStoreViewVisible();
    }
    constructor(sceneController, mainpageController){
        this.bodyContainer = document.getElementById('main-page-body-container');
        const initTimestamp = Date.now();
        this.homepageController = new UIMHomepageController();
        this.modeSelectorDetailsController = new UIMModeSelectorDetailsController((matchType, botMapSetting)=>{
            void this.homepageController.matchmakingController.startGame(matchType, botMapSetting);
        }, (matchType)=>{
            this.modeSelectorController.redirectToCasualWithTransition(matchType);
        }, sceneController);
        this.modeSelectorController = new UIModeSelectorController(initTimestamp, (matchType, botMapSetting)=>{
            void this.homepageController.matchmakingController.startGame(matchType, botMapSetting);
        }, (matchType, botMapSetting)=>{
            this.modeSelectorDetailsController.show(matchType, botMapSetting);
        });
        new UIMLeaderboardController();
        this.lobbyController = new UIMLobbyController();
        this.storeController = new UIMStoreController();
        const morePageOptions = UIUtilsEjsVariables.isUserOnDiscordMobile ? {
            faqExternalUrl: FAQ_URL
        } : undefined;
        mountMorePage('more-page-container', ()=>{
            navigateToPage(getMobileRulebookUrl(), false, true);
            const currentScene = uiManager.sceneController.scene;
            if (currentScene == undefined) return;
            StorageWrapper.setLastScene(currentScene);
        }, morePageOptions);
        this.sceneController = sceneController;
        this.navigationController = mainpageController.navigationController;
        this.swipeNavigation = new Splide('.splide', {
            type: 'slide',
            perPage: 1,
            start: 2,
            arrows: false,
            pagination: false,
            flickMaxPages: 1,
            flickPower: 100,
            perMove: 1,
            noDrag: 'input, textarea, .m-no-drag, .m-no-drag *'
        }).mount();
        const track = document.getElementById('splide01-track');
        if (track) {
            track.addEventListener('touchstart', (e)=>{
                if (e.touches.length > 1) this.swipeNavigation.refresh();
            });
        }
        let didUserSwipe = false;
        this.swipeNavigation.on('drag', ()=>{
            didUserSwipe = true;
        });
        this.swipeNavigation.on('move', (e)=>{
            if (!didUserSwipe) return;
            didUserSwipe = false;
            this.slideChange(e);
        });
    }
}
